var _path, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleplay = function SvgGoogleplay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_205_704",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 23,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0204 15.7518C29.3271 16.495 29.3274 17.6997 28.0204 18.4432L9.47041 28.9941C8.16375 29.7373 7.10449 29.1221 7.10449 27.6192L7.10449 6.57606C7.10449 5.0735 8.16345 4.45774 9.47041 5.20109L28.0204 15.7518Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_205_704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0204 15.7537C29.3271 16.4969 29.3274 17.7017 28.0204 18.4451L9.47041 28.996C8.16375 29.7392 7.10449 29.1241 7.10449 27.6211V6.57802C7.10449 5.07545 8.16345 4.45969 9.47041 5.20305L28.0204 15.7537Z",
    fill: "url(#paint0_linear_205_704)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08567 4.90234L19.1618 16.905L6.92969 29.3819L7.08567 4.90234Z",
    fill: "url(#paint1_linear_205_704)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60254 2.42871L19.1606 16.9057L23.4889 12.7766L4.60254 2.42871Z",
    fill: "url(#paint2_linear_205_704)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.163 16.9023L25.7892 23.5812L5.99414 30.26L19.163 16.9023Z",
    fill: "url(#paint3_linear_205_704)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_704",
    x1: 29.0005,
    y1: 17.0995,
    x2: 20.4802,
    y2: 17.0995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBDA09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_205_704",
    x1: 6.92969,
    y1: 19.2169,
    x2: 15.8958,
    y2: 17.9633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_205_704",
    x1: 8.4329,
    y1: 5.33888,
    x2: 17.3164,
    y2: 16.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_205_704",
    x1: 20.7391,
    y1: 19.2306,
    x2: 13.148,
    y2: 32.1178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2414E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02554"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleplay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/googleplay.f71639e3.svg";
export { ForwardRef as ReactComponent };